import { jsx as C } from "react/jsx-runtime";
const r = ({
  size: H
}) => {
  switch (H) {
    case "sm":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M12.7948 12.3333H5.87183C5.53506 12.3333 5.25 12.2167 5.01667 11.9833C4.78333 11.75 4.66667 11.4649 4.66667 11.1282V2.20517C4.66667 1.86839 4.78333 1.58333 5.01667 1.35C5.25 1.11667 5.53506 1 5.87183 1H10.5L14 4.5V11.1282C14 11.4649 13.8833 11.75 13.65 11.9833C13.4167 12.2167 13.1316 12.3333 12.7948 12.3333ZM10 5V2H5.87183C5.8205 2 5.7735 2.02139 5.73083 2.06417C5.68806 2.10683 5.66667 2.15383 5.66667 2.20517V11.1282C5.66667 11.1795 5.68806 11.2265 5.73083 11.2692C5.7735 11.3119 5.8205 11.3333 5.87183 11.3333H12.7948C12.8462 11.3333 12.8932 11.3119 12.9358 11.2692C12.9786 11.2265 13 11.1795 13 11.1282V5H10ZM3.20517 15C2.86839 15 2.58333 14.8833 2.35 14.65C2.11667 14.4167 2 14.1316 2 13.7948V5H3V13.7948C3 13.8462 3.02139 13.8932 3.06417 13.9358C3.10683 13.9786 3.15383 14 3.20517 14H10V15H3.20517Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M19.1923 18.5H8.80775C8.30258 18.5 7.875 18.325 7.525 17.975C7.175 17.625 7 17.1974 7 16.6923V3.30775C7 2.80258 7.175 2.375 7.525 2.025C7.875 1.675 8.30258 1.5 8.80775 1.5H15.75L21 6.75V16.6923C21 17.1974 20.825 17.625 20.475 17.975C20.125 18.325 19.6974 18.5 19.1923 18.5ZM15 7.5V3H8.80775C8.73075 3 8.66025 3.03208 8.59625 3.09625C8.53208 3.16025 8.5 3.23075 8.5 3.30775V16.6923C8.5 16.7692 8.53208 16.8398 8.59625 16.9038C8.66025 16.9679 8.73075 17 8.80775 17H19.1923C19.2693 17 19.3398 16.9679 19.4038 16.9038C19.4679 16.8398 19.5 16.7692 19.5 16.6923V7.5H15ZM4.80775 22.5C4.30258 22.5 3.875 22.325 3.525 21.975C3.175 21.625 3 21.1974 3 20.6923V7.5H4.5V20.6923C4.5 20.7693 4.53208 20.8398 4.59625 20.9038C4.66025 20.9679 4.73075 21 4.80775 21H15V22.5H4.80775Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M15.9935 15.4167H7.33979C6.91882 15.4167 6.5625 15.2708 6.27083 14.9792C5.97917 14.6875 5.83333 14.3312 5.83333 13.9102V2.75646C5.83333 2.33549 5.97917 1.97917 6.27083 1.6875C6.5625 1.39583 6.91882 1.25 7.33979 1.25H13.125L17.5 5.625V13.9102C17.5 14.3312 17.3542 14.6875 17.0625 14.9792C16.7708 15.2708 16.4145 15.4167 15.9935 15.4167ZM12.5 6.25V2.5H7.33979C7.27563 2.5 7.21688 2.52674 7.16354 2.58021C7.11007 2.63354 7.08333 2.69229 7.08333 2.75646V13.9102C7.08333 13.9744 7.11007 14.0331 7.16354 14.0865C7.21688 14.1399 7.27563 14.1667 7.33979 14.1667H15.9935C16.0577 14.1667 16.1165 14.1399 16.1698 14.0865C16.2233 14.0331 16.25 13.9744 16.25 13.9102V6.25H12.5ZM4.00646 18.75C3.58549 18.75 3.22917 18.6042 2.9375 18.3125C2.64583 18.0208 2.5 17.6645 2.5 17.2435V6.25H3.75V17.2435C3.75 17.3077 3.77674 17.3665 3.83021 17.4198C3.88354 17.4733 3.94229 17.5 4.00646 17.5H12.5V18.75H4.00646Z",
          fill: "currentColor"
        }
      );
  }
}, t = ({
  size: H
}) => {
  switch (H) {
    case "sm":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M13.0107 12.6086H5.83667C5.41689 12.6086 5.05917 12.4608 4.7635 12.1651C4.46783 11.8695 4.32 11.5118 4.32 11.0919V2.06159C4.32 1.6417 4.46783 1.28398 4.7635 0.988422C5.05917 0.692755 5.41689 0.544922 5.83667 0.544922H10.4477L14.5273 4.62459V11.0919C14.5273 11.5118 14.3795 11.8695 14.0838 12.1651C13.7882 12.4608 13.4304 12.6086 13.0107 12.6086ZM9.67733 5.39492V2.06159H5.83667V11.0919H13.0107V5.39492H9.67733ZM2.98667 15.4586C2.56689 15.4586 2.20917 15.3108 1.9135 15.0151C1.61783 14.7195 1.47 14.3618 1.47 13.9419V4.65642H2.98667V13.9419H10.356V15.4586H2.98667Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M19.515 18.9104H8.75399C8.12433 18.9104 7.58774 18.6887 7.14424 18.2452C6.70074 17.8019 6.47899 17.2653 6.47899 16.6354V3.08994C6.47899 2.46011 6.70074 1.92352 7.14424 1.48019C7.58774 1.03669 8.12433 0.814941 8.75399 0.814941H15.6705L21.79 6.93444V16.6354C21.79 17.2653 21.5682 17.8019 21.1247 18.2452C20.6812 18.6887 20.1447 18.9104 19.515 18.9104ZM14.515 8.08994V3.08994H8.75399V16.6354H19.515V8.08994H14.515ZM4.47899 23.1854C3.84933 23.1854 3.31274 22.9637 2.86924 22.5202C2.42574 22.0769 2.20399 21.5403 2.20399 20.9104V6.98219H4.47899V20.9104H15.533V23.1854H4.47899Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M16.2632 15.7595H7.29566C6.77094 15.7595 6.32379 15.5747 5.9542 15.2051C5.58462 14.8357 5.39983 14.3885 5.39983 13.8637V2.57577C5.39983 2.0509 5.58462 1.60375 5.9542 1.23431C6.32379 0.864723 6.77094 0.679932 7.29566 0.679932H13.0594L18.159 5.77951V13.8637C18.159 14.3885 17.9742 14.8357 17.6046 15.2051C17.235 15.5747 16.7879 15.7595 16.2632 15.7595ZM12.0965 6.74243V2.57577H7.29566V13.8637H16.2632V6.74243H12.0965ZM3.73316 19.322C3.20844 19.322 2.76129 19.1372 2.3917 18.7676C2.02212 18.3982 1.83733 17.951 1.83733 17.4262V5.81931H3.73316V17.4262H12.9448V19.322H3.73316Z",
          fill: "currentColor"
        }
      );
  }
}, l = ({
  size: H = "md",
  weight: V = "default"
}) => {
  switch (V) {
    case "bold":
      return /* @__PURE__ */ C(t, { size: H });
    case "book":
    case "default":
      return /* @__PURE__ */ C(r, { size: H });
  }
};
export {
  l as default
};
//# sourceMappingURL=DIconFileCopy.js.map
